import { Permission } from "models/Permission";
import { AppStore } from "App/Store";

export const allowGenreRead = (store: AppStore) => {
  const { allowTables } = store.UserToken;
  for (const allowTable of allowTables) {
    const permission = new Permission(allowTable.allow.split(""));
    switch (allowTable.table) {
      case "genre":
        if (!permission.isUserReadable() || !permission.isGroupReadable() || !permission.isOtherReadable()) {
          return false;
        }
        break;
      case "genre_title":
        if (!permission.isUserReadable()) {
          return false;
        }
        break;
      case "genre_url":
        if (!permission.isUserReadable()) {
          return false;
        }
        break;
      default:
        break;
    }
  }
  return true;
};
